var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"to":_vm.$prismic.linkResolver(_vm.card)}},[_c('PrismicImage',{attrs:{"img":_vm.card.data.card_image,"w":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }